import { useRequestStore } from '@/features/requests/requests'

export const searchApi = {
  getRequestStore() {
    return useRequestStore();
  },

  async search(query: string, signal?: AbortSignal) {
    return await this.getRequestStore().send(`search`, {
      method: "POST",
      payload: { query },
      onlyWithAuth: true,
      noCache: true,
      signal,
    })
  },
};
